import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Map from "@babel/runtime-corejs3/core-js-stable/map";
import { noop } from 'lodash';
var INSTANT_INVALIDATION = 0;
export var Cache = /*#__PURE__*/function () {
  function Cache() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      defaultTtl: INSTANT_INVALIDATION
    },
        defaultTtl = _ref.defaultTtl;

    _classCallCheck(this, Cache);

    _defineProperty(this, "cache", new _Map());

    _defineProperty(this, "defaultTtl", INSTANT_INVALIDATION);

    this.defaultTtl = defaultTtl;
  }

  _createClass(Cache, [{
    key: "get",
    value: function get(key) {
      var item = this.cache.get(key);

      if (item) {
        var _value = item.value,
            expires = item.expires;

        if (window.Date.now() <= expires) {
          return _value;
        } else {
          this.cache.delete(key);
        }
      }
    }
  }, {
    key: "put",
    value: function put(key, value) {
      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref2$ttl = _ref2.ttl,
          ttl = _ref2$ttl === void 0 ? this.defaultTtl : _ref2$ttl,
          _ref2$onRemove = _ref2.onRemove,
          onRemove = _ref2$onRemove === void 0 ? noop : _ref2$onRemove;

      this.cache.set(key, {
        value: value,
        expires: window.Date.now() + ttl,
        onRemove: onRemove
      });
    }
  }, {
    key: "remove",
    value: function remove(key) {
      var _this$cache$get = this.cache.get(key),
          value = _this$cache$get.value,
          onRemove = _this$cache$get.onRemove;

      if (typeof onRemove === 'function') {
        onRemove(key, value);
      }

      this.cache.delete(key);
    }
  }]);

  return Cache;
}();